<template>
	<div>
		<div class="homebox" ref="floatButton" :style="{'left': left + 'px', 'top': top + 'px', 'z-index': zIndex}">
			<div class="item" @click.stop="toIndex()" v-if="backIndex">
				<img src="../../../static/img/12.png" class="img" alt="">
				<div class="text">首页</div>
			</div>
			<div class="item" @click.stop="online()" v-if="service">
				<img src="../../../static/img/3.png" class="img" alt="">
				<div class="text">客服</div>
			</div>
		</div>
	</div>
</template>
 
<script>
export default {
	props: {
		backIndex: false,
		service: false,
		zIndex: {
            default: 9999
        },
	},
	data() {
		return {
			left: 305,
			top: 500,
		};
	},

	created: function () {
		var that = this;
	},

	mounted() {
		var that = this;
		that.setEvent();
	},

	methods: {
		setEvent() {
			var that = this;

			that.$nextTick(() => {
				const floatButton = that.$refs.floatButton;
				floatButton.addEventListener("touchstart", (e) => {
					floatButton.style.transition = "none";
					document.body.style.overflowY = "hidden";
				});

				// 在拖拽的过程中，组件应该跟随手指的移动而移动。
				floatButton.addEventListener("touchmove", (e) => {
					if (e.targetTouches.length === 1) {
						let touch = e.targetTouches[0];
						that.left = touch.clientX - 20;
						that.top = touch.clientY - 25;
					}
				});

				// 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
				floatButton.addEventListener("touchend", (e) => {
					document.body.style.overflowY = "auto";
					floatButton.style.transition = "all 0.3s";
					if (that.left > document.documentElement.clientWidth / 2) {
						that.left = document.documentElement.clientWidth - 70;
					} else {
						that.left = 15;
					}
				});
			});
		},

		online() {
			open("https://work.weixin.qq.com/kfid/kfcb4a8d83f709f6097");
		},
		toIndex() {
			var that = this;
			that.$router.push({
				path: "/index",
			});
		},
	},
};
</script>

<style lang='less' scoped>
.homebox {
	position: fixed;

	.item {
		width: 50px;
		height: 50px;
		background: #ffffff;
		box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;

		.img {
			height: 19px;
			margin-bottom: 6px;
		}
		.text {
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 12px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/page/components/homebtn.vue